module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foldedHover-4e48b1e652873165f56703a1b9554175.jpg";